/**
 * Enum values used by the editable client Factsheet form.
 * Keep these values aligned with the options rendered in clientFactsheet.js so
 * other Factsheet editors (for example meeting-note sync) cannot accept values
 * that the form itself cannot produce.
 */
export const CLIENT_FACTSHEET_ENUM_OPTIONS = {
  smoker: ['No', 'Yes'],
  marriageStatus: ['Single', 'Married']
};
